import React from "react";
import {Redirect} from "react-router-dom";

class Logout extends React.Component {
    render() {
        return(
            sessionStorage.removeItem("jwt"),
            <Redirect to="/login"/>
        )
    }
}

export default Logout;
